<template>
    <button
        class="export-btn"
        :class="buttonClass"
        @click="handleClick"
    >
        <slot></slot>
    </button>
</template>

<script>
export default {
    props: {
        format: {
            type: String,
            required: true,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        isSuccess: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        buttonClass() {
            if (this.isLoading) {
                return 'loading';
            } else if (this.isSuccess) {
                return 'success';
            }
            return '';
        },
    },
    methods: {
        handleClick() {
            this.$emit('click', this.format);
        },
    },
};
</script>

<style scoped>
.export-btn {
    background: linear-gradient(45deg, #00ffff, #0080ff);
    border: none;
    color: white;
    padding: 0rem 1rem;
    border-radius: 6px;
    font-weight: bold;
    cursor: pointer;
    height: 45px;
    transition: all 0.3s ease;
}

.export-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 255, 255, 0.5);
}

.export-btn.loading {
    background: linear-gradient(45deg, #ffaa00, #ff8800);
}

.export-btn.success {
    background: linear-gradient(45deg, #00ff00, #00aa00);
}
</style>